"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.intersection = void 0;
exports.intersection = (target, source) => {
    const common = [];
    const hash = new Set(target);
    const found = new Set();
    for (const value of source) {
        if (hash.has(value) && !found.has(value)) {
            common.push(value);
            found.add(value);
        }
    }
    return [...common];
};
//# sourceMappingURL=intersection.js.map